import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { selectedTripSelector } from '../../../features/tripcenter/tripControlSlice';
import { setNeedBounding } from '../../../features/map/mapSlice';

const GoogleMapTripBounder = ({ map }) => {
    const selectedTrip = useSelector(selectedTripSelector);
    const dispatch = useDispatch();

    useEffect(() => {
        const mapBounder = () => {
            if (!map || !window.google || !selectedTrip) {
                return;
            }

            // Wait for full trip payload. Selected trip is first set from list item,
            // then replaced by getOneTrip response that contains complete routePath.
            if (!selectedTrip?.fullyLoaded) {
                return;
            }

            const routePath = selectedTrip?.route?.routePath;
            if (!Array.isArray(routePath) || routePath.length === 0) {
                dispatch(setNeedBounding(false));
                return;
            }

            let bounds = new window.google.maps.LatLngBounds();
            let hasValidPoint = false;

            // Sanitize and validate coordinates before extending bounds
            routePath.forEach(point => {
                const lat = parseFloat(point.lat);
                const lng = parseFloat(point.lng);

                if (!isNaN(lat) && !isNaN(lng) && lat !== 0 && lng !== 0) {
                    bounds.extend(new window.google.maps.LatLng(lat, lng));
                    hasValidPoint = true;
                }
            });

            if (hasValidPoint) {
                // Fit the map to the bounds with padding
                map.fitBounds(bounds, { left: 350, bottom: 100, top: 75, right: 25 });
            }

            dispatch(setNeedBounding(false));
        };

        mapBounder();
    }, [map, selectedTrip, dispatch]);

    return null;
};

export default GoogleMapTripBounder;
